import { render, staticRenderFns } from "./appReportPreviewMobile.vue?vue&type=template&id=c066cc14&scoped=true"
import script from "./appReportPreviewMobile.vue?vue&type=script&lang=js"
export * from "./appReportPreviewMobile.vue?vue&type=script&lang=js"
import style0 from "./appReportPreviewMobile.vue?vue&type=style&index=0&id=c066cc14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c066cc14",
  null
  
)

export default component.exports